import { ServerErrorTemplate } from 'templates/ServerError';

export default function ServerErrorPage() {
  return (
    <>
      <ServerErrorTemplate />
    </>
  );
}
